module.exports = __webpack_public_path__ + "media/Strong-woman-song.ded13802.mp3";